import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'jhi-column-filter-text',
    template: `
        <form #f='ngForm'>
            <input type="text" class="form-control" placeholder="{{ textPlaceHolder | translate }}" [(ngModel)]="filter.value" name="{{filter.key}}">
            <br/>
            <div class="footer text-center"><br>
                <button type="submit" class="btn btn-primary btn-sm me-1" [disabled]="!f.valid" (click)="apply(f)">{{ 'apply' | translate }}</button>
                <button class="btn btn-secondary btn-sm" (click)="reset(f)">{{ 'reset' | translate }}</button>
            </div>
        </form>
    `
})
export class ColumnFilterTextComponent implements OnInit {
    @Input() filter: any;

    @Output() onApply = new EventEmitter();
    @Output() onReset = new EventEmitter();

    textPlaceHolder: string;

    ngOnInit(): void {
        this.textPlaceHolder = this.filter.placeholder ? this.filter.placeholder : 'column-filter.contains.text.placeholder';
    }

    apply(form) {
        if (!form.valid) {
            return;
        }
        this.onApply.emit();
    }

    reset(form) {
        form.reset();
        this.onReset.emit();
    }
}
